import { useTranslation } from "react-i18next";

import organizationTypes from "astrid-firestore/src/api/organizations/constants/organizationTypes";

import featureFlags from "../../../../authorization/constants/featureFlags";
import useFeatureFlag from "../../../../authorization/hooks/useFeatureFlag";
import useHasRole from "../../../../authorization/hooks/useHasRole";

export default function useOrganizationSettingsMenuOptions({ organization }) {
	const { t } = useTranslation();

	const hasFlatteningFeature = useFeatureFlag(featureFlags.FLATTENING);
	const hasRole = useHasRole();

	if (organization?.type === organizationTypes.PRODUCER) {
		return [
			{
				path: "vendors",
				name: t("vendorSettings"),
			},
			{
				path: "language",
				name: t("language", "Language"),
			},
			{
				path: "finance",
				name: t("finance", "Finance"),
			},
			{
				path: "studio",
				name: t("studio", "Studio"),
			},
		];
	}

	if (organization?.type === organizationTypes.PUBLISHER) {
		return [
			{
				path: "vendors",
				name: t("vendorSettings"),
			},
			{
				path: "distribution",
				name: t("distribution", "Distribution"),
				hidden: !hasFlatteningFeature || !hasRole("owner", "admin"),
			},
			{
				path: "legacyDistribution",
				name: t("legacyDistribution", "Distribution (old)"),
			},
			{
				path: "export-presets",
				name: t("exportPresets", "Export presets"),
				hidden: !hasFlatteningFeature || !hasRole("owner", "admin"),
			},
			{
				path: "finance",
				name: t("finance", "Finance"),
			},
			{
				path: "language",
				name: t("language", "Language"),
			},
			{
				path: "blurbs",
				name: t("announce", "Announce"),
			},
			{
				path: "contractors",
				name: t("contractors", "Contractors"),
			},
		];
	}

	return [];
}
